<template>
<div class="card">
    <div class="card-body help-card-body">
       <div class="text-center">
            <h4>Things to look for</h4>
        </div>
        <hr>
        <ul>
          <li>Use of articles (e.g., a, an, and the) is unnecessary and should be mostly eliminated from the r&egrave;sum&egrave;.</li>
          <li>Eliminate the use of personal pronouns (e.g., I, me, you, they, them, us).</li>
          <li>Avoid complete sentences when writing an effective r&egrave;sum&egrave;. Highly descriptive cluses and phrases can communicate quite forcefully.</li>
          <li>Be concise. Eliminate all unnecessary words from the r&egrave;sum&egrave; that do not enhance it's meaning or impact.</li>
          <li>Begin most r&egrave;sum&egrave; sentences or statements with a verb. Doing so will almost automatically force you to be brief and concise. Try it!</li>
        </ul>
    </div>
</div>
</template>

<script>

export default {
  name: 'preview',
  components: {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style>

</style>
